import react, { useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { purple } from "@mui/material/colors";
import { BiLogoTypescript } from "react-icons/bi";
import {
  FaAws,
  FaDocker,
  FaGithub,
  FaJava,
  FaPhp,
  FaPython,
  FaReact,
} from "react-icons/fa";
import { RiFlutterFill } from "react-icons/ri";
import { IoLogoNodejs } from "react-icons/io";
import { TbBrandCSharp, TbBrandKotlin } from "react-icons/tb";
import { FaDartLang } from "react-icons/fa6";
import { SiGooglecloud, SiMongodb } from "react-icons/si";
import { GrMysql } from "react-icons/gr";
import { IoLogoFirebase } from "react-icons/io5";
import { VscAzure } from "react-icons/vsc";

import { FaNode } from "react-icons/fa";
import {} from "react-icons/ri";
import { SiExpress } from "react-icons/si";
import { motion } from "framer-motion";

export default function CustomTabs({
  techStacks,
  title = "  Technologies we use",
  fontSize = "text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px]  ",
}) { 
  const [selectedStack, setSelectedStack] = useState(
    Object.keys(techStacks)[0]
  );

  return (
    <section className=" space-y-5 md:space-y-8 ">
      <div className="md:w-10/12 lg:w-8/12 xl:w-7/12 mx-auto ">
        <motion.h2 
          initial={{ opacity: 0, y: 40 }} 
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.3 }}
          className={` ${fontSize}   font-bold capitalize text-center text-dark font-butler `}
        >
          {title}
        </motion.h2>
      </div>

      <div className="space-y-10 px-4">
        {/* <ul className='grid max-[330px]:grid-cols-1  grid-cols-3 md:grid-cols-6 xl:grid-cols-5 gap-4  justify-items- md:justify-items-stretch ' > */}
        <ul className="flex  justify-center md:justify-items-stretch flex-wrap gap-x-9">
          {Object.keys(techStacks).map((stack, index) => (
            <li
              key={stack}
              className={` ${index === 3 && " col-span-2 xl:col-span-1"}  w-max md:w-auto  relative   flex items-start justify-center text-center border-none after:content-[''] after:absolute after:bottom-0 after:left-0 after:h-[2px] after:bg-[#DF73FF]  after:transition-all after:duration-300  ${selectedStack === stack ? "after:w-full text-dark" : "after:w-0 text-gray-500"} cursor-pointer `}
            >
              <button
                className="py-1  w-full"
                onClick={() => setSelectedStack(stack)}
              >
                <span>
                  <span>{stack}</span>
                </span>
              </button>
            </li>
          ))}
        </ul>

        <div>
          <ul className="flex justify-center flex-wrap gap-4 md:gap-8 ">
            {techStacks[selectedStack].map((tech, index) => (
              <li key={tech.id} aria-label={tech.name} title={tech.name}>
                <span itemProp="item">
                  {tech.icon}
                  <span itemProp="name" className="sr-only">
                    {tech.name}
                  </span>
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
